import { render, staticRenderFns } from "./HostelCheckOutHistory.vue?vue&type=template&id=1c0ec055&scoped=true&"
import script from "./HostelCheckOutHistory.vue?vue&type=script&lang=js&"
export * from "./HostelCheckOutHistory.vue?vue&type=script&lang=js&"
import style0 from "./HostelCheckOutHistory.vue?vue&type=style&index=0&id=1c0ec055&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0ec055",
  null
  
)

export default component.exports